import { connect } from 'react-redux';
import { useEffect } from 'react'


const Clip = ({

}) => {
    useEffect(() => {
        window.location.replace('https://www.podeux.com/search');
    }, []);

    return (
        <div>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(Clip);